import { withStyles } from "@material-ui/core"
import TopicTable from "./TopicTable.view"

const styles = theme => ({
  container: {
    flex: "1 1 100px",
    overflow: "auto",
    padding: "0 8px",
    margin: "0 5px",
    "&::-webkit-scrollbar": {
      width: 5,
      height: 5,
      paddingLeft: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      maxHeight: 10,
      borderRadius: 2,
      backgroundColor: "#d7d7d7",
    },
    "&::-webkit-scrollbar-corner": {
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: "calc(100vh - 345px)",
      height: "100vh",
    },
  },
  rowContainer: {
    "&:nth-child(2n + 1)": {
      background: "#EBEBEB",
    },
  },
})

export default withStyles(styles)(TopicTable)
